var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-skeleton-loader',{attrs:{"width":737,"height":48}},[_c('rect',{attrs:{"width":"24","height":"24","y":"12","x":"8"}}),_vm._v(" "),_c('rect',{attrs:{"width":"120","height":"12","y":"10","x":"36"}}),_vm._v(" "),_c('rect',{attrs:{"width":"100","height":"12","y":"26","x":"36"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }